const $ = jQuery.noConflict();
import 'slick-carousel';

const sliders = document.querySelectorAll('.component-slider');

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		if (sliders.length) {
			sliders.forEach((slider) => {
				if (!slider.hasAttribute('data-slick')) {
					const parentWithSettings = slider.closest('[data-slick]');

					if (parentWithSettings) {
						slider.setAttribute(
							'data-slick',
							parentWithSettings.getAttribute('data-slick')
						);
					}
				}
			});

			$('.component-slider').slick();

			$(window).on('block-library-change', function () {
				$('.component-slider').slick('refresh');
			});
		}
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
